<template>
  <img
    v-if="gameIcon"
    :class="$style.icon"
    :src="gameIcon.logo"
    :srcset="`${gameIcon.logo} 1x, ${gameIcon.logo2x} 2x`"
    alt=""
  />
</template>

<script setup lang="ts">
import type { FantasyGameId } from '~/types/fantasy'
import { gameIcons } from './constants'

defineOptions({
  name: 'FantasyGameIcon'
})

const props = defineProps<{
  game?: FantasyGameId | null
}>()

const gameIcon = computed(() =>
  props.game ? gameIcons[props.game] ?? null : null
)
</script>

<style lang="scss" module>
.icon {
  object-fit: contain;
}
</style>
